<template>
  <v-container>
    <v-row>
      <v-col
        cols=12
        sm=2
        md=3
        align="center"
        justify="center"
      >
        <v-img
          :src="require('../assets/logo.png')"
          max-height="200"
          contain
        ></v-img>
      </v-col>

      <v-col
        cols=12
        sm=7
        md=7
        class="text-center text-sm-left"
      >
        <h1>MAOC (N)</h1>
        <h3>MARITIME ANALYSIS AND OPERATIONS CENTRE (NARCOTICS)</h3>
        <p>{{ $t('message') }}</p>
      </v-col>

      <v-col
        cols=12
        sm=3
        md=2
      >
        <v-row
          class="px-3 mt-1"
        >
          <LanguagePicker />
        </v-row>
        <v-row
          class="px-3 px-sm-0 mt-0"
        >
          <request-import
            @fileImport="fileImport"
          ></request-import>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LanguagePicker from './LanguagePicker'
import RequestImport from './maoc_form/RequestImport'

export default {
  name: 'RequestHeader',
  components: {
    LanguagePicker,
    RequestImport
  },
  methods: {
    fileImport (file) {
      this.$emit('fileImport', file)
    }
  }
}
</script>
